import { TextField, Tooltip } from "@mui/material";
import React, { useState } from "react";
import ButtonComponent from "../shared/button/button.component";
import { AiGeneratedMessageCopyIcon, FalkonAiFilledWhiteIcon } from "../../icon";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { UtilityService } from "../../services/UtilityService";
import { ChannelAiService } from "../../services/channels/ChannelAiService";
import AnimateComponent from "../shared/loaders/animate-loader.component";
import messageGenerateAnimation from "../shared/loaders/website-refine-message-animation.json";

interface IProps {

}

const WebsiteRefineMessage: React.FC<IProps> = (Props: IProps) => {

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);

    const [messageToneOptions, setMessageToneOptions] = useState<{ Label: string, Status: boolean }[]>(
        [{ Label: "Formal", Status: true }, { Label: "Friendly", Status: false }, { Label: "Casual", Status: false }, { Label: "Empathetic", Status: false },]
    );

    const [messageLengthOptions, setMessageLengthOptions] = useState<{ Label: string, Status: boolean }[]>(
        [{ Label: "Shorten", Status: false }, { Label: "Expand", Status: false }]
    );

    const [originalText, setOriginalText] = useState<string>("");
    const [aiGeneratedText, setAiGeneratedText] = useState<string>("");
    const [aiAnimation, setAiAnimation] = useState<boolean>(false);
    const [buttonActive, setButtonActive] = useState<boolean>(false);


    const handleTextChange = (e) => {
        if (!buttonActive) {
            setButtonActive(true)
        }
        setOriginalText(e.target.value)
    }

    const handleMessageTone = (value) => {
        if (!buttonActive && !messageToneOptions.find(x => x.Label === value).Status) {
            setButtonActive(true)
        }
        setMessageToneOptions(messageToneOptions.map(x => { return { ...x, Status: x.Label === value } }))
    }

    const handleMessageLength = (value) => {
        if (!buttonActive && !messageLengthOptions.find(x => x.Label === value).Status) {
            setButtonActive(true)
        }
        setMessageLengthOptions(messageLengthOptions.map(x => x.Label === value ? { ...x, Status: true } : { ...x, Status: false }))
    }

    const handleRefineMessage = () => {
        setAiAnimation(true)
        ChannelAiService.getWebsiteRefinedMessage({
            message: originalText,
            improve: false,
            length: messageLengthOptions.find(x => x.Status)?.Label || "",
            tone: messageToneOptions.find(x => x.Status).Label,
            translate: "",
        }).then((res) => {
            setAiAnimation(false)
            setAiGeneratedText(res.data.refined_message)
            setButtonActive(false)
        }).catch(() => {
            setAiAnimation(false)
            setAiGeneratedText("Please try again")
            setButtonActive(false)
        })
    }

    return (
        <div className="w-p-100 h-v-100 d-flex justify-center align-center">
            <div className={`d-flex flex-direction bg-color-secondary website-refine-message-box h-48 min-h-48 w-p-90 p-2 br-4`}>
                <div className={`d-flex ${IsMobileDevice ? "flex-direction justify-between min-h-10 py-1" : ""}`}>
                    <div className={` ${IsMobileDevice ? "flex-1 w-p-96 mx-auto mb-1" : "flex-1"}`}>
                        <div className="h6-semibold">
                            Message Tone
                        </div>
                        <div className={`d-flex flex-wrap`}>
                            {messageToneOptions.map(x => {
                                return (
                                    <div className={`mr-1 my-1 d-flex justify-center align-center br-4  ${IsMobileDevice ? "h-4 h5 px-1" : "h-4 h5-medium px-2"} ${x.Status ? "bg-color-primary-light color-secondary b-none" : "website-refine-message-buttons"} c-pointer`} onClick={() => handleMessageTone(x.Label)}>
                                        {x.Label}
                                    </div>
                                )
                            }
                            )}
                        </div>
                    </div>
                    {!IsMobileDevice && <div className="bg-color-text-field-border my-1" style={{ width: "2px" }}>

                    </div>}
                    <div className={`${IsMobileDevice ? "w-p-96 mx-auto" : "pl-2"}`}>
                        <div className="h6-semibold">
                            Message length
                        </div>
                        <div className="d-flex">
                            {messageLengthOptions.map(x => {
                                return (
                                    <div className={`mr-1 my-1 d-flex justify-center align-center ${IsMobileDevice ? "h-4 h5 px-1" : "h-4 h5-medium px-2"} br-4 ${x.Status ? "bg-color-primary-light color-secondary b-none" : "website-refine-message-buttons"} c-pointer`} onClick={() => { handleMessageLength(x.Label) }}>
                                        {x.Label}
                                    </div>
                                )
                            }
                            )}
                        </div>
                    </div>
                </div>
                <div className={`flex-1 website-refine-message-box-text-border br-3 d-flex flex-direction ${IsMobileDevice ? "w-p-96 mx-auto" : "mt-2"}`}>
                    <div className="flex-1 d-flex flex-direction">
                        <div className="h6-semibold px-2 pt-1 min-h-2 color-website-refine-message-box-header">
                            Original text
                        </div>
                        <div className="mx-2 flex-1 bb-primary-background-pink-4">
                            <TextField
                                value={originalText}
                                onChange={handleTextChange}
                                placeholder="Type your text here to get started..."
                                variant="standard"
                                multiline
                                minRows={4}
                                maxRows={6}
                                fullWidth
                                className="p-0 h-p-100"
                                InputProps={{ className: "h-p-100 h5-medium " }}
                                inputProps={{ className: " h-p-100" }}
                            />
                        </div>
                    </div>

                    <div className="flex-1 d-flex flex-direction">
                        <div className="h6-semibold px-2 pt-1 color-website-refine-message-box-header ">
                            AI Generated text <Tooltip title={"Copy"}><AiGeneratedMessageCopyIcon className="w-2 h-2 mx-2 c-pointer" onClick={() => { UtilityService.copyTextFromEmbedding(aiGeneratedText) }} /></Tooltip>
                        </div>
                        <div className="mx-2 flex-1">
                            {aiAnimation ?
                                <AnimateComponent LoaderAnimation={messageGenerateAnimation} className="h-p-100 w-16 mx-auto d-flex align-center justify-center" />
                                :
                                <TextField
                                    value={aiGeneratedText}
                                    variant="standard"
                                    multiline
                                    minRows={4}
                                    maxRows={6}
                                    fullWidth
                                    className="p-0 h-p-100"
                                    InputProps={{ className: `h-p-100 h5-medium ${aiGeneratedText === "Please try again" && "color-primary-danger"}`, readOnly: true }}
                                    inputProps={{ className: "h-p-100" }}
                                />
                            }
                        </div>
                    </div>
                </div>
                <ButtonComponent Loading={aiAnimation} ButtonLabel="Generate" ButtonRightIcon={FalkonAiFilledWhiteIcon} Variant={(originalText && buttonActive) ? "website-refine-message-btn" : "disabled-btn"} ClassName={` br-5 h4-regular py-0 ${IsMobileDevice ? "h-4 w-p-96 mx-auto" : "h-5 w-p-100"}`} OnClick={handleRefineMessage} />
            </div>
        </div>
    )
}

export default WebsiteRefineMessage;